import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'cart-discounted-price',
  templateUrl: './cart-discounted-price.component.html',
  styleUrls: ['./cart-discounted-price.component.scss']
})
export class CartDiscountedPriceComponent {
  @Input() discountedPrice: number;
  @Input() currency: string;
}
